import { KEY_VALUE_SEPARATOR, PAIR_SEPARATOR } from './constants';

const concat = (key: string, value: string | boolean | null) =>
  !!value || value === false ? `${key}${KEY_VALUE_SEPARATOR}${value}` : key;

const combine = (a: string, b: string) => (a ? `${a}${PAIR_SEPARATOR}${b}` : b);

export default function serializeToString(
  object: Record<string, string | boolean | null> | string,
) {
  if (!object) {
    return '';
  }

  if (typeof object === 'string') {
    return object;
  }

  const keys = Object.keys(object);
  if (keys.length === 0) {
    return '';
  }

  return keys
    .map((key) => concat(key, object[key]))
    .reduce((a, b) => combine(a, b), '');
}
